import React from "react";
import { ChevronDown, Sparkles } from "lucide-react";

const fmtMoney = (v) =>
  `R$ ${Number(v || 0).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
const fmtCurto = (v) => {
  const n = Number(v || 0);
  if (n >= 1000000) return `R$ ${(n / 1000000).toFixed(1).replace(".", ",")}M`;
  if (n >= 1000) return `R$ ${(n / 1000).toFixed(1).replace(".", ",")}k`;
  return fmtMoney(n);
};
const fmtNum = (v) => Number(v || 0).toLocaleString("pt-BR");

// Card de um canal de venda. Fechado mostra o essencial; aberto mostra as
// variações com quantidade, faturamento, ticket e a fatia de cada uma dentro do
// grupo. Clicar numa variação filtra a lista.
export default function CardGrupo({ grupo, aberto, onAlternar, onFiltrarVariacao, variacaoAtiva }) {
  const vazio = grupo.count === 0;
  const comDados = (grupo.variacoes || []).filter((v) => v.count > 0);
  const semDados = (grupo.variacoes || []).filter((v) => !v.count);

  return (
    <div
      className={`rounded-xl border transition-colors ${
        aberto ? "border-primary/40 bg-primary/[0.03]" : "border-border bg-card"
      } ${vazio && !aberto ? "opacity-55" : ""}`}
      data-e2e={`grupo-${grupo.key}`}
    >
      <button
        type="button"
        onClick={onAlternar}
        className="w-full px-3 py-2.5 text-left"
        data-e2e={`grupo-abrir-${grupo.key}`}
      >
        <div className="flex items-center gap-2">
          <span className={`w-2.5 h-2.5 rounded-full ${grupo.cor} ${vazio ? "opacity-40" : ""}`} />
          <span className="text-sm font-bold flex-1 truncate">{grupo.label}</span>
          <span className="text-sm font-black tabular-nums">{fmtNum(grupo.count)}</span>
          <ChevronDown className={`w-4 h-4 text-muted-foreground transition-transform ${aberto ? "rotate-180" : ""}`} />
        </div>
        <div className="flex items-center gap-2 mt-1.5 pl-4.5">
          <div className="h-1.5 flex-1 rounded-full bg-muted overflow-hidden">
            <div className={`h-full rounded-full ${grupo.cor}`} style={{ width: `${Math.max(grupo.pctDoTotal, vazio ? 0 : 2)}%` }} />
          </div>
          <span className="text-[11px] font-semibold text-muted-foreground tabular-nums">
            {fmtCurto(grupo.revenue)}
          </span>
          <span className="text-[11px] font-bold text-muted-foreground tabular-nums w-9 text-right">
            {Math.round(grupo.pctDoTotal)}%
          </span>
        </div>
      </button>

      {aberto ? (
        <div className="px-2 pb-2">
          <div className="rounded-lg bg-background/60 border border-border/60 divide-y divide-border/60">
            {comDados.length === 0 ? (
              <p className="px-3 py-3 text-xs text-muted-foreground text-center">
                Nenhum pedido deste canal no período.
              </p>
            ) : null}
            {comDados.map((v) => (
              <button
                key={v.key}
                type="button"
                onClick={() => onFiltrarVariacao(v)}
                data-e2e={`variacao-${v.key}`}
                className={`w-full px-3 py-2 text-left hover:bg-muted/70 transition-colors first:rounded-t-lg last:rounded-b-lg ${
                  variacaoAtiva === v.key ? "bg-primary/10" : ""
                }`}
              >
                <div className="flex items-center gap-1.5">
                  {v.logo ? (
                    <img src={v.logo} alt="" className="w-3.5 h-3.5 object-contain rounded-sm" />
                  ) : null}
                  <span className="text-xs font-semibold truncate flex-1">{v.label}</span>
                  {v.automatico ? (
                    <Sparkles className="w-3 h-3 text-emerald-500 shrink-0" title="Pedido que entra sozinho" />
                  ) : null}
                  <span className="text-xs font-bold tabular-nums">{fmtNum(v.count)}</span>
                </div>
                <div className="flex items-center gap-1.5 mt-0.5 text-[10px] text-muted-foreground tabular-nums whitespace-nowrap">
                  <span>{fmtCurto(v.revenue)}</span>
                  <span className="opacity-50">·</span>
                  <span>ticket {fmtMoney(v.ticket)}</span>
                  <span className="ml-auto font-bold">{Math.round(v.pctDoGrupo)}% do canal</span>
                </div>
              </button>
            ))}
            {semDados.length > 0 ? (
              <p className="px-3 py-1.5 text-[10px] text-muted-foreground/70">
                Sem pedidos: {semDados.map((v) => v.label).join(", ")}
              </p>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
